import PasswordResetPage from '../pages/PasswordResetPage';

import DashboardPage from '../pages/DashboardPage';

import ActiveResearchesPage from '../pages/ActiveResearchesPage';
import ActiveResearchFormPage from '../pages/ActiveResearchFormPage';
import ActiveResearchResultPage from '../pages/ActiveResearchResultPage';

import { ReactComponent as NavDashboard } from '../images/nav-dashboard.svg';
import AccountPage from '../pages/AccountPage';
import AdBlankPage from '../pages/AdBlankPage';
import AdStudyPage from '../pages/AdStudyPage';
import AssistancePage from '../pages/AssistancePage';
import ComparativeStudiesPage from '../pages/ComparativeStudiesPage';
import ComparativeStudyFormPage from '../pages/ComparativeStudyFormPage';
import MyFoldersContentPage from '../pages/FolderContentPage';
import MyFoldersFormPage from '../pages/FolderFormPage';
import MyFoldersPage from '../pages/FoldersPage';
import LoginPage from '../pages/LoginPage';
import MaintenancePage from '../pages/MaintenancePage';
import MarketStudiesFormPage from '../pages/MarketStudiesFormPage';
import MarketStudiesPage from '../pages/MarketStudiesPage';
import MarketStudiesResultPage from '../pages/MarketStudiesResultPage';
import PieceworkPage from '../pages/PieceworkPage';

const routes = [
  {
    path: '/',
    exact: true,
    title: 'Tableau de bord',
    Component: DashboardPage,
    isAuthRoute: true,
  },
  {
    path: '/maintenance',
    title: 'Maintenance',
    Component: MaintenancePage,
    isAuthRoute: false,
  },
  {
    path: '/connexion',
    exact: true,
    title: 'Inscription',
    Component: LoginPage,
    isAuthRoute: false,
  },
  {
    path: '/recuperation-mot-de-passe',
    exact: true,
    title: 'Changement de mot de passe',
    Component: PasswordResetPage,
    isAuthRoute: false,
  },
  {
    path: '/premier-mot-de-passe',
    exact: true,
    title: 'Premier de mot de passe',
    Component: PasswordResetPage,
    isAuthRoute: false,
  },
  {
    path: '/dashboard',
    nav: 1,
    navName: 'Dashboard',
    exact: true,
    title: 'Tableau de bord',
    Component: DashboardPage,
    Icon: NavDashboard,
    isAuthRoute: true,
  },
  {
    path: '/pige-classique',
    nav: 2,
    navName: 'Pige classique',
    exact: true,
    title: 'Pige classique',
    Component: PieceworkPage,
    isAuthRoute: true,
  },
  {
    path: '/recherches-actives',
    nav: 3,
    navName: 'Recherches actives',
    exact: true,
    title: 'Recherches actives',
    Component: ActiveResearchesPage,
    isAuthRoute: true,
  },
  {
    path: '/recherche-active-creation',
    exact: true,
    title: 'Recherche active - Créer',
    Component: ActiveResearchFormPage,
    isAuthRoute: true,
  },
  {
    path: '/recherche-active-modification/:id',
    exact: true,
    title: 'Recherche active - Modifier',
    Component: ActiveResearchFormPage,
    isAuthRoute: true,
  },
  {
    path: '/recherche-active-resultat/:id',
    exact: true,
    title: 'Recherche active - Résultat',
    Component: ActiveResearchResultPage,
    isAuthRoute: true,
  },
  {
    path: '/mes-dossiers',
    nav: 4,
    navName: 'Mes dossiers',
    exact: true,
    title: 'Mes dossiers',
    Component: MyFoldersPage,
    isAuthRoute: true,
  },
  {
    path: '/mes-dossiers-creation',
    exact: true,
    title: 'Mes dossiers - Création',
    Component: MyFoldersFormPage,
    isAuthRoute: true,
  },
  {
    path: '/details-dossier/:folderId',
    exact: true,
    title: 'Mes dossiers - Détails',
    Component: MyFoldersContentPage,
    isAuthRoute: true,
  },
  {
    path: '/creation-annonce-dossier/:folderId/:id',
    exact: true,
    title: 'Mes dossiers - Création Ad',
    Component: AdStudyPage,
    isAuthRoute: true,
  },
  {
    path: '/etudes-de-marche',
    nav: 5,
    navName: 'Etudes de marché',
    exact: true,
    title: 'Etudes de marché',
    Component: MarketStudiesPage,
    isAuthRoute: true,
  },
  {
    path: '/etudes-de-marche-creation',
    exact: true,
    title: 'Etudes de marché - Création',
    Component: MarketStudiesFormPage,
    isAuthRoute: true,
  },
  {
    path: '/etudes-de-marche-modification/:id',
    exact: true,
    title: 'Etudes de marché - Modification',
    Component: MarketStudiesFormPage,
    isAuthRoute: true,
  },
  {
    path: '/etude-de-marche-resultats/:id',
    exact: true,
    title: 'Etude de marché - Résultats',
    Component: MarketStudiesResultPage,
    isAuthRoute: true,
  },
  {
    path: '/etudes-comparatives',
    navName: 'Etudes comparatives',
    nav: 6,
    exact: true,
    title: 'Etudes comparatives',
    Component: ComparativeStudiesPage,
    isAuthRoute: true,
  },
  {
    path: '/etude-comparative-creation',
    exact: true,
    title: 'Etudes comparatives - Création',
    Component: ComparativeStudyFormPage,
    isAuthRoute: true,
  },
  {
    path: '/etude-comparative-modification/:id',
    exact: true,
    title: 'Etudes comparatives - Modification',
    Component: ComparativeStudyFormPage,
    isAuthRoute: true,
  },
  {
    path: '/assistance',
    nav: 7,
    navName: 'Assistance',
    exact: true,
    title: 'Assistance',
    Component: AssistancePage,
    isAuthRoute: true,
  },
  {
    path: '/mon-compte',
    nav: 9,
    navName: 'Mon compte',
    exact: true,
    title: 'Mon compte',
    Component: AccountPage,
    isAuthRoute: true,
  },
  {
    path: '/ads/:id',
    exact: true,
    title: 'ad-detail',
    Component: AdBlankPage,
    isAuthRoute: true,
  },
];

export default routes;
